export const API_URL = 'https://pdkubdx25f.execute-api.ap-northeast-1.amazonaws.com/dev';

export const EDMS_DOMAIN = 'dev.edms.bitriver.jp';

export const cognito = {
  REGION: 'ap-northeast-1',
  USER_POOL_ID: 'ap-northeast-1_qJijlvtWI',
  APP_CLIENT_ID: '24vacbgc1he06tmtifi2jb0fa8',
  IDENTITY_POOL_ID: 'ap-northeast-1:04720fc1-9a62-4d79-8dcf-1c6357139481',
};

export const appSync = {
  url: 'https://fkhtsvr2lbcpflpcxpar2mbc34.appsync-api.ap-northeast-1.amazonaws.com/graphql',
  region: 'ap-northeast-1',
};

export const zipStrage = {
  AWSS3: {
    bucket: 'edms-zip-dev',
    region: 'ap-northeast-1',
  },
};
